export default __webpack_public_path__ + "static/media/grey-arrow-back.1c5100e2.svg";